import React, { useMemo } from "react";
import styled from "styled-components";
import { Button, Row } from "reactstrap";
import PropTypes from "prop-types";
import BankDetailsItems from "./items";

const BankDetails = (props) => {
  const generateKey = () => Math.round(Math.random() * 10000).toString();

  const [groups, setGroups] = React.useState((props.detailsData && props.detailsData.results?.length > 0) ? props.detailsData.results.map((i, inx) => ({
    key: generateKey(),
    suffix: generateKey(),
    accordion_status: false,
    bank_correspondents: [],
    ...i,

  })) : [{ key: generateKey(), suffix: generateKey(), accordion_status: true, bank_correspondents: [], }]);

  const handleAddGroup = () => {
    setGroups(prev => [...prev, { accordion_status: true, key: generateKey(), suffix: generateKey(), bank_correspondents: [] }]);
  };

  const handleDeleteGroup = key => {
    setGroups(prev => prev.filter(i => i.key !== key));
  };

  const sortedGroups = useMemo(() => {
    return groups
    .map((group, index) => ({ ...group, index }))
    .sort((a, b) => a.id - b.id)
  }, [groups])

  return (
    <>

      <Row>
        <div className="text-end">
          <Button color="success" onClick={handleAddGroup}>Add bank details</Button>
        </div>
      </Row>
      <PaymentTypeStyled>
        {sortedGroups.map((i, inx) => <BankDetailsItems
          key={i.key}
          inx={inx}
          isLoading={props.isLoading}
          data={i}
          isFormSubmit={props.isFormSubmit}
          setGroups={setGroups}
          permissions={props.permissions}
          accordion_status={i?.accordion_status}
          suffix={`|${i.suffix}|`}
          onDelete={groups.length > 1 ? () => handleDeleteGroup(i.key) : null}
          setEditBank={props.setEditBank}
          legal_entity_loading={props.legal_entity_loading}
          legal_entity_data={props.legal_entity_data}
          loading_details={props.loading_details}
          getBankCorespondents={props.getBankCorespondents}
          deleteBankCorespondent={props.deleteBankCorespondent}
          updateBankCorespondent={props.updateBankCorespondent}
          addBankCorespondent={props.addBankCorespondent}
          loading_corespondent={props.loading_corespondent}
          updateBankDetails={props.updateBankDetails}
          deleteBankDetails={props.deleteBankDetails}
        // countries={getFilteredCountries()}
        // countries={getFilteredCountries(i.countries)}
        // onChangeCountries={val => handleChangeCountries(val, i.key)}
        />)}

      </PaymentTypeStyled>
    </>
  );
};

BankDetails.propTypes = {
  isFormSubmit: PropTypes.bool,
  isLoading: PropTypes.bool,
  detailsData: PropTypes.object,
  permissions: PropTypes.any,

  legal_entity_loading: PropTypes.bool,
  legal_entity_data: PropTypes.shape({
    sizePerPage: PropTypes.number,
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }),
  loading_details: PropTypes.bool,
  setEditBank: PropTypes.func,
  getBankCorespondents: PropTypes.func,
  deleteBankCorespondent: PropTypes.func,
  updateBankCorespondent: PropTypes.func,
  addBankCorespondent: PropTypes.func,
  loading_corespondent: PropTypes.bool,
  legal_entity_data: PropTypes.any,
  legal_entity_loading: PropTypes.bool,
  updateBankDetails: PropTypes.func,
  deleteBankDetails: PropTypes.func,
};

const PaymentTypeStyled = styled.div`
`;

export default BankDetails;
